// Layer-safe textured polygon room MESH (room-mesh.glb) for the dollhouse. The baked surface textures
// already contain the room's lighting, so they render UNLIT (MeshBasicMaterial) — lit materials
// double-darken them to black (the "totally dark" bug). DoubleSide so interior walls show from inside.
// The glb is baked in the room frame, so it renders at IDENTITY (same contract as RoomSplatGS).
// Unlike the inspector's RoomMesh, this NEVER moves the camera — the dollhouse owns its camera/controls.
import { useEffect } from "react";
import { useGLTF } from "@react-three/drei";
import * as THREE from "three";

/** Swap every mesh's material to an UNLIT MeshBasicMaterial that shows the baked albedo as authored. */
export function applyUnlitBakedMaterials(scene: THREE.Object3D) {
  scene.traverse((o: THREE.Object3D) => {
    const m = o as THREE.Mesh;
    if (m.isMesh && m.material) {
      const src = (Array.isArray(m.material) ? m.material[0] : m.material) as THREE.MeshStandardMaterial;
      m.material = new THREE.MeshBasicMaterial({
        map: src.map ?? null,
        color: src.map ? 0xffffff : src.color ? src.color.getHex() : 0xcfcabf,
        side: THREE.DoubleSide,
        toneMapped: false,
      });
    }
  });
}

export function RoomMeshGLB({ url }: { url: string }) {
  const { scene } = useGLTF(url);
  useEffect(() => {
    applyUnlitBakedMaterials(scene);
  }, [scene]);
  return <primitive object={scene} />;
}
